export var PRIMARY_SUMMARY_DATA = "PRIMARY_SUMMARY_DATA";
export var SECONDARY_SUMMARY_DATA = "SECONDARY_SUMMARY_DATA";
